import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ArrowLongRightSvgComponent } from '@uc/shared/svg';
import { CdnPathPipe } from '@uc/utilities';
import { GuideCategoryUrl } from '@uc/web/shared/data-models';

@Component({
	selector: 'uc-guides-carousel-footer',
	templateUrl: './guides-carousel-footer.component.html',
	imports: [NgOptimizedImage, RouterLink, ArrowLongRightSvgComponent, CdnPathPipe],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GuidesCarouselFooterComponent {
	categoryTitle = input<string>();
	description = input<string>();
	categoryUrl = input<GuideCategoryUrl>();
}
